<template lang='pug'>
.content
  label.control-label Rule Name*
  ed-input(
    :endpoint='api.$.approval.getNewRuleId'
    placeholder = 'Rule Name',
    v-model = 'name'
    ref = 'RuleName'
    @keyup='changeRuleName'
  )

  .row.form-group
    p.col-md-2.row
      strong Conditions
    .col-md-3
      | &nbsp;&nbsp;
      label 
        checkbox.inline(
          option-label='This rule has parallel routes'
          :option-status='useParallelApprovalRoutes'
          @change-status='changeUsingParallelRoutes'
        )
    ed-select.inline.col-md-1(
      open-direction='over'
      v-if='useParallelApprovalRoutes'
      placeholder='Select routes'
      v-model='MaxRoutes'
      :options='maxRoutesValues'
      label='label'
      @select='updateMaxRoutes($event)'
    )
    

  rule(
    :endpoint='api.$.approval.getRule'
    v-if='optionsAvailable'
    :self='approvalRule[type.rule]'
    :children='children'
    :depth=0
    :conditions='approvalRule[type.rule].Conditions'
    :actions='approvalRule[type.rule].Actions'
    :label='"WHEN"'
    :conditionOptions='options'
    :actionOptions='actionOptions'
    :routeValues='routeValues'
    :useParallelApprovalRoutes='useParallelApprovalRoutes'
  )

  //- pre {{approvalRule}}
</template>

<script>
import Rule from './rule'
import type from './type'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
import Checkbox from '@/core/components/edCheckbox/checkbox'
import routesValues from './route-values'
var approvalRuleUtils = require('./approvalRuleUtils')

export default{
  components: {
    Rule,
    Checkbox
  },

  computed: {
    children() {
      return (this.approvalRule[type.rule].Children && this.approvalRule[type.rule].Children[type.rule])
        ? this.list(this.approvalRule[type.rule].Children[type.rule])
        : null
    },
    optionsAvailable() {
      return this.options.Options
    }
  },

  data() {
    return {
      dragStarted: false,
      useParallelApprovalRoutes: false,
      approvalRule: {
        '@xmlns:xsd': 'http://www.w3.org/2001/XMLSchema',
        '@xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
        RuleDTO: {
          Id: 0,
          Operator: 'Or',
          Conditions: {
            ConditionDTO: {
              Id: 0,
              Values: {
                ConditionValueDTO: null
              }
            }
          },
          Actions: null,
          Children: null
        }
      },
      type,
      list: utils.collection.list,
      options: {},
      actionOptions: {},
      name: '',
      ruleId: 0,
      maxRoutesValues: [],
      routeValues: [],
      routesValues,
      allRoutesAreUsed: true
    }
  },

  created() {
    // initialize Rule Array Ids
    this.$store.state.approvalRuleIds = {
      ruleIds: [],
      conditionIds: [],
      actionIds: []
    }
    this.$store.state.routeNumbers = []

    // capture Save Rule event
    EventBus.$off(events.APPROVAL_RULE.SAVED).$on(events.APPROVAL_RULE.SAVED, r => {
      this.validateRule()
    })

    // capture Open Rule event
    EventBus.$off(events.APPROVAL_RULE.OPENED).$on(events.APPROVAL_RULE.OPENED, r => {
      this.openRule(r)
    })

    let validRule = true
    EventBus.$on(events.APPROVAL_RULE.VALIDATION_COMPLETED, r => {
      var index = this.$store.state.SaveIds && this.$store.state.SaveIds.indexOf(r.data.Id.toString())

      if (validRule) {
        validRule = r.data.valid
      }

      if (index > -1 && this.$store.state.SaveIds) {
        this.$store.state.SaveIds.splice(index, 1)
      }
      // save rule just when there are no elements to validate
      if (this.$store.state.SaveIds && this.$store.state.SaveIds.length === 0) {
        if (validRule) {
          this.$store.state.SaveIds = null
          this.saveRule()
        } else {
          alert('Please complete all required fields to successfully save your rule.')
          validRule = true
        }
      }
    })

    EventBus.$off(events.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE).$on(events.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE, this.moveRule)

    Object.keys(this.routesValues.maxRoutes).forEach((key, val) => {
      this.maxRoutesValues.push({
        id: this.routesValues.maxRoutes[key],
        label: key
      })
    })
  },

  beforeDestroy() {
    EventBus.$off(events.APPROVAL_RULE.VALIDATION_COMPLETED)
  },

  methods: {
    changeUsingParallelRoutes(e) {
      this.useParallelApprovalRoutes = e
      if (!e) {
        this.approvalRule[type.rule].MaxRoutes = null
      } else {
        this.approvalRule[type.rule].MaxRoutes = this.MaxRoutes.id
      }
      EventBus.$emit('usingParallelRoutesChanged', e)
      this.enableSaveButton()
    },
    setOptions(obj) {
      const contexts = JSON.parse(obj)
      if (contexts) {
        this.options = contexts.ConditionOptions
        this.actionOptions = contexts.ActionOptions
        this.$store.state.originalActionOptions = {
          options: utils.copy(contexts.ActionOptions.Options),
          additionalOptions: utils.copy(contexts.ActionOptions.AdditionalOptions)
        }
        this.$store.state.originalConditionOptions = {
          options: utils.copy(contexts.ConditionOptions.Options)
        }
      }
    },

    validateRule() {
      this.allRoutesAreUsed = true
      if (this.useParallelApprovalRoutes) {
        for (var i = 1; i <= parseInt(this.MaxRoutes.id); i++) {
          if (this.$store.state.routeNumbers.filter(routeNumber => routeNumber === i).length === 0) {
            this.allRoutesAreUsed = false
          }
        }
      }
      // check if name is set on modal
      if (!this.name) {
        alert('Cannot save rule. Rule Name is empty.')
        this.$refs.RuleName.$refs.input.focus()
      } else if (!this.allRoutesAreUsed) {
        alert("Please select at least one time each route number from one to the selected parallel routes' number.")
      } else {
        this.approvalRule.name = this.name
        // get all child component ids (ruleIds, conditionIds, actionIds)
        this.$store.state.SaveIds = []
        this.getAllIdsIntoStore(this.approvalRule[type.rule])
        EventBus.$emit(events.APPROVAL_RULE.VALIDATE_COMPONENTS)
      }
    },

    getAllIdsIntoStore(rule) {
      // insert rule ids for validation purpose
      if (rule && rule.Id) {
        this.$store.state.SaveIds.push(rule.Id.toString())
      }

      // insert condition ids for validation purpose
      if (rule.Conditions && rule.Conditions[type.condition] && this.list(rule.Conditions[type.condition]).length > 0) {
        let conditionsList = this.list(rule.Conditions[type.condition])
        conditionsList.map(condition => {
          this.$store.state.SaveIds.push(condition.Id.toString())
        })
      }

      // insert action ids for validation purpose
      if (rule.Actions && rule.Actions[type.action] && this.list(rule.Actions[type.action]).length > 0) {
        let actionsList = this.list(rule.Actions[type.action])
        actionsList.map(action => {
          this.$store.state.SaveIds.push(action.Id.toString())
        })
      }

      if (rule.Children && rule.Children[type.rule]) {
        let rules = this.list(rule.Children[type.rule])
        rules.map(localRule => {
          if (localRule) {
            this.getAllIdsIntoStore(localRule)
          }
        })
      }
    },

    saveRule() {
      var rule = {
        ArrayOfRuleDTO: this.approvalRule
      }

      var payload = {
        ruleId: this.ruleId,
        ruleName: this.name,
        ruleJSON: JSON.stringify(rule)
      }

      this.api.forms.post(this.api.$.approval.saveRule, payload).then(this.setMessage)
    },

    setMessage(r) {
      const isValid = r.data.IsValid
      const message = r.data.ItemError.Message
      if (isValid !== true) {
        alert(message)
        switch (r.data.ItemError.Area) {
          case 'Rule Name':
            this.$refs.RuleName.$refs.input.focus()
            break
        }
      } else {
        EventBus.$emit(events.APPROVAL_RULE.VALIDATION_PASSED)
        EventBus.$emit(events.APPROVAL_RULE.REFRESH)
      }
    },

    openRule(r) {
      if (r && r.data) {
        var ruleId = r.data.id

        // new rule
        if (ruleId === 0) {
          this.name = ''
          // request to backend. Insert a deleted new line in ApprovalRule table whenever a new rule must be added
          // request will return the id of the new added rule to complete rule/condition/action ids on frontend
          this.api.forms.post(this.api.$.approval.getNewRuleId).then(this.setRuleId)
        } else {
          // existing rule
          this.ruleId = ruleId
          // Get Rule from DB
          var payload = { ruleId: ruleId }
          this.api.forms.post(this.api.$.approval.getRule, payload).then(this.setRule)
        }
      } else {
        alert('Error. Invalid response.')
      }
    },

    setRuleId(r) {
      if (r && r.data !== '') {
        const id = r.data.RuleId
        if (id) {
          this.ruleId = id
          var firstConditionId = id * 10
          var firstActionId = ((id * 100) - 1)

          this.approvalRule[type.rule].Id = id
          this.approvalRule[type.rule].Conditions[type.condition].Id = firstConditionId
          this.setRoutes(this)

          this.$store.state.approvalRuleIds.ruleIds.push(id)
          this.$store.state.approvalRuleIds.conditionIds.push(firstConditionId)
          this.$store.state.approvalRuleIds.actionIds.push(firstActionId)
        }

        // Get condition and action context options
        this.setOptions(r.data.ContextOptions)
      } else {
        alert('Error. Cannot create Id for new rule')
      }
    },

    setRule(r) {
      if (r && r.data !== '') {
        var rule = JSON.parse(r.data.Rule)
        this.name = rule.Name
        var ruleJSON = JSON.parse(rule.ConditionsJSON)
        this.approvalRule = ruleJSON.ArrayOfRuleDTO
        this.setRoutes(this)

        // Get condition and action context options
        this.setOptions(r.data.ContextOptions)
      } else {
        alert('Error. Cannot get rule from database')
      }
    },

    updateMaxRoutes(e) {
      this.approvalRule[type.rule].MaxRoutes = e.id
      this.routeValues = []
      Object.keys(this.routesValues.routeNumber).forEach((key, val) => {
        if (key === 'All' || this.routesValues.routeNumber[key] <= e.id) {
          this.routeValues.push({
            id: this.routesValues.routeNumber[key],
            label: key
          })
        }
      })
      EventBus.$emit('updateMaxRoutesChanged', e.id)
      this.enableSaveButton()
    },

    setRoutes(vm) {
      if (typeof vm.approvalRule[type.rule].MaxRoutes !== 'undefined' && vm.approvalRule[type.rule].MaxRoutes !== null) {
        vm.MaxRoutes = {label: vm.approvalRule[type.rule].MaxRoutes.toString(), id: vm.approvalRule[type.rule].MaxRoutes}
      } else {
        vm.MaxRoutes = {label: '2', id: 2}
        vm.approvalRule[type.rule].MaxRoutes = null
      }
      vm.useParallelApprovalRoutes = typeof vm.approvalRule[type.rule].MaxRoutes !== 'undefined' && vm.approvalRule[type.rule].MaxRoutes !== null

      Object.keys(vm.routesValues.routeNumber).forEach((key, val) => {
        if (key === 'All' || vm.routesValues.routeNumber[key] <= vm.MaxRoutes.id) {
          vm.routeValues.push({
            id: vm.routesValues.routeNumber[key],
            label: key
          })
        }
      })
    },
    changeRuleName() {
      this.enableSaveButton()
    },

    enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton)
    },

    moveRule(r) {
      if (this.approvalRule[type.rule].Children && this.approvalRule[type.rule].Children[type.rule]) {
        // transform all RuleDTO and Children properties to array
        this.updateRulesBeforeMoving()

        // find rule to move
        let ruleToMove = this.findInArrayAndExecAction(this.approvalRule[type.rule].Children[type.rule],
          r.data.fromRuleId, 'find')

        // find destination rule
        if (ruleToMove) {
          this.findInArrayAndExecAction(this.approvalRule[type.rule].Children[type.rule],
          r.data.toRuleId, 'move', ruleToMove)
        }
      }
    },

    updateRulesBeforeMoving() {
      if (!Array.isArray(this.approvalRule[type.rule].Children[type.rule])) {
        this.approvalRule[type.rule].Children[type.rule] = [
          this.approvalRule[type.rule].Children[type.rule]
        ]
      }
      this.approvalRule[type.rule].Children[type.rule].map(item => {
        if (item.Children && item.Children[type.rule] &&
          !Array.isArray(item.Children[type.rule])) {
          item.Children[type.rule] = [
            item.Children[type.rule]
          ]
        }
      })
    },

    findInArrayAndExecAction(arr, ruleIdToFind, action, param) {
      let node
      // loop rules
      if (arr && Array.isArray(arr)) {
        arr.some((item, key) => {
          if (+item.Id === ruleIdToFind) {
            node = this.executeActionOnArray(action, arr, key, param)
            return true
          } else if (item.Children && item.Children[type.rule]) {
            // loop children
            node = this.findInArrayAndExecAction(item.Children[type.rule], ruleIdToFind, action, param)
            if (node) return true
          }
          return false
        })
      }
      return node
    },

    executeActionOnArray(action, arr, key, param) {
      switch (action) {
        case 'find':
          return arr.splice(key, 1).shift()

        case 'move':
          arr.splice(key, 0, param)
          break
      }
      return false
    }
  }
}
</script>

<style scoped lang='scss'>
@import '~@/assets/sass/_variables.scss';

  p.title {
    font-weight: $font-weight-bold;
    font-size: $font-size-base;
    color: $border;
    margin-bottom: .5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-rule/index.vue